import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const PanelTitle: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(15),
    lineHeight: pxToRem(26),
    color: theme.siteVariables.colors.charcoal['250'],
    letterSpacing: theme.siteVariables.letterSpacingMedium,
});
